import {
    CaretRightOutlined,
    RightOutlined,
    MinusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Steps,
    Button,
    message,
    Form,
    Input,
    Image,
    Carousel,
    Card,
    Divider,
    Select,
    DatePicker,
    Radio,
    Checkbox,
    Space,
    Avatar,
    AutoComplete,
} from "antd";
import React, { useEffect, useState } from "react";
import commonService from "../../api/common.service";
import timeSlotService from "../../api/time.slot.service";
import { SUCCESS_STATUS } from "../../utility/Constants";
const { Option } = Select;

function TapTimeSlotView(props) {

    //  const [timeSlotList, setTimeSlotList] = useState([props.timeSlotListData]);
    const [dayList, setDayList] = useState([]);



    useEffect(() => {
        commonService.dayList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setDayList(res.data.response_data);
            }
        });
    }, []);


    return (
        <div>
            <Form.List name="day_slot">
                {(fields, { add, remove }) => (
                    <>

                        <Row>
                            <Col>
                                <Form.Item>
                                    {
                                        props.mode == "ADD" ? (
                                            <Button
                                                className="custom-button-green"
                                                onClick={() => {
                                                    add();
                                                }}
                                                icon={<PlusOutlined />}
                                            >
                                                Add Time Slot
                                            </Button>
                                        ) : ''
                                    }

                                </Form.Item>
                            </Col>
                        </Row>

                        {fields.map(({ key, name, ...restField }) => (
                            <Space
                                key={key}
                                style={{
                                    display: "flex",
                                    marginBottom: 8,
                                }}
                                align="baseline"
                            >
                                <Form.Item
                                    {...restField}
                                    name={[name, "day_id"]}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Day",
                                        },
                                    ]}
                                >
                                    <Select
                                        className="text-left"
                                        defaultValue="Select"
                                        style={{ width: "200px" }}
                                    >
                                        {dayList.length > 0
                                            ? dayList.map((day_list) => (
                                                <Option
                                                    key={day_list.day_id}
                                                    value={day_list.day_id}
                                                >
                                                    {day_list.day_name}
                                                </Option>
                                            ))
                                            : ""}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, "time_slot_id"]}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Time",
                                        },
                                    ]}
                                >
                                    <Select
                                        className="text-left"
                                        defaultValue="Select"
                                        style={{ width: "250px" }}
                                    >
                                        {props.timeSlotListData.length > 0
                                            ? props.timeSlotListData.map((time_slot) => (
                                                <Option
                                                    key={time_slot.time_slot_id}
                                                    value={time_slot.time_slot_id}
                                                >
                                                    {time_slot.time_slot}
                                                </Option>
                                            ))
                                            : ""}
                                    </Select>
                                </Form.Item>

                                {
                                    props.mode == "ADD" ? (<MinusCircleOutlined onClick={() => remove(name)} />) : ''
                                }


                            </Space>
                        ))}



                    </>
                )}


                {/* <Form.Item>
                    <Button
                        className="custom-button-green"

                        icon={<PlusOutlined />}
                    >
                        Generate Schedule
                    </Button>

                </Form.Item> */}
            </Form.List>
        </div>
    )
}

export default TapTimeSlotView